import React from 'react';
import { useHistory } from 'react-router-dom'

import Toolbar from '@material-ui/core/Toolbar';
import CssBaseline from '@material-ui/core/CssBaseline';

import ScrollTop from "@base/ScrollTop";
import Navbar from "@base/Navbar";
import Drawer from '@base/Drawer';

import { ProcessoContext } from "@contexts/ProcessoContext";

export function Dashboard(props) {
  const { processo, setProcesso } = React.useContext(ProcessoContext);
  let history = useHistory();

  const detach = () => {
    setProcesso({ id: undefined, name: undefined, dataLimitePostagem: undefined });
    history.push("/processos");
  }

  return (
    <>
      <CssBaseline />
      <Navbar
        open={props.open}
        click={props.handleDrawerOpen}
        nameApp={processo.id ? processo.nome + " / " + process.env.REACT_APP_NAME_GENERAL : process.env.REACT_APP_NAME_GENERAL }
        handleLogoutProcess={processo.id ? detach : null}
        handleLogout={props.handleLogout}
      />
      <Drawer
        open={props.open}
        click={props.handleDrawerClose}
        darkMode={props.darkMode}
        setDarkMode={props.setDarkMode}
      />
      <Toolbar id="top" />

      <ScrollTop {...props} />
    </>
  );
}

export default Dashboard;
